import { observer } from 'mobx-react-lite';
import React from 'react';
import { useAlertFormStore } from '../../../alertFormClass';
import { setupFiltersMap } from './setupFiltersMap';
import style from './SetupFiltersSection.module.css';

export const SetupFiltersSection = observer(() => {
  const form = useAlertFormStore();
  const filters = Object.keys(form.setupFilters);
  return (
    <>
      {filters.map((filter) => {
        const Component = setupFiltersMap[filter];
        return (
          <div key={filter} className={style.container}>
            <div></div>
            <Component />
          </div>
        );
      })}
    </>
  );
});
